import styled from "styled-components";
import { defaultTheme } from "styles/theme/default";

export const Greeting = styled.h1`
  font-family: ${defaultTheme.fonts.title};
  font-size: 1.1rem;
  color: ${defaultTheme.colors.black};
  margin: 0 0 16px;
`;

export const TilesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const Tile = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  background: ${defaultTheme.colors["white-100"]};
  border: 1px solid ${defaultTheme.colors["white-box"]};
  border-radius: 12px;
  padding: 16px;
  text-align: left;
  cursor: pointer;
  min-height: 88px;

  &:disabled {
    cursor: default;
  }

  &:active:not(:disabled) {
    background: ${defaultTheme.colors["base-light"]};
  }
`;

export const TileLabel = styled.span`
  font-size: 0.8rem;
  color: ${defaultTheme.colors["gray-300"]};
`;

export const TileValue = styled.span`
  font-family: ${defaultTheme.fonts.title};
  font-size: 1.6rem;
  font-weight: 700;
  color: ${defaultTheme.colors["base-dark"]};
`;
